import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FicheIntervention} from 'app/models/ficheIntervention.model';
import {Piece} from 'app/models/piece.model';
import {PieceService} from 'app/services/piece.service';
import {FuseConfirmationService} from '@fuse/services/confirmation';
import {UserService} from 'app/core/user/user.service';
import {Etage} from '../../../../models/etage.model';
import {Niveau} from "../../../../models/niveau.model";

@Component({
    selector: 'app-piece-v2',
    templateUrl: './piece-v2.component.html',
    styleUrls: ['./piece-v2.component.scss']
})
export class PieceV2Component implements OnInit {
    @Input() currentFicheIntervention: FicheIntervention;
    @Input() idDossierIntervention: number;
    @Input() pieces: Piece[] = [];
    @Input() niveaux: Niveau[] = [];

    @Output() refresh: EventEmitter<any> = new EventEmitter<any>();
    @Output() editPiece: EventEmitter<Piece> = new EventEmitter<Piece>();

    constructor(private pieceService: PieceService, private _userService: UserService, private fuseConfirmationService: FuseConfirmationService) {
    }

    ngOnInit(): void {
    }


    delete(id: number): void {
        if (this.isAdmin) {
            const confirmation = this.fuseConfirmationService.open({
                title: 'Suppression d\'une pièce',
                message: 'Êtes-vous certain de vouloir supprimer cette pièce',
                actions: {
                    confirm: {
                        label: 'Supprimer'
                    }
                }
            });

            confirmation.afterClosed().subscribe((result) => {
                if (result === 'confirmed') {
                    this.pieceService.delete(id).subscribe(
                        () => {
                            this.refresh.emit(true);
                        },
                        (error) => {
                            console.log(error);
                        });
                }
            });
        }
    }

    getEtage(piece: Piece): string {
        return this.niveaux.find((niveau: Niveau) => niveau.id === piece.niveau_id)?.niveau || '';
    }

    get isAdmin(): boolean {
        return this._userService.getCurrentUser().role_id == 1;
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }
}
